import LoginRegisterTab from '../../../organisms/customer/guest/login-register-tab'

const RegisterPageComponent = ({ dynamicAreasLogin, dynamicAreasRegister }) => {
	return (
		<LoginRegisterTab
			defaultTab="register"
			dynamicAreasLogin={dynamicAreasLogin}
			dynamicAreasRegister={dynamicAreasRegister}
		/>
	)
}

RegisterPageComponent.defaultProps = {}
RegisterPageComponent.propTypes = {}

export default RegisterPageComponent
